// MMT2Slice - Two Paired Auth Aggregate datasets (Agg1 & Agg2)
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../../AxiosInterceptor/axiosInterceptor';

const initialDatasetState = () => ({
	totalCount: 0,
	page: 0,
	pageSize: 50,
	collectionName: '',
	data: [],
	loading: false,
	error: false,
	lastRefreshedDate: ''
});

const initialState = {
	agg1Data: initialDatasetState(),
	agg2Data: initialDatasetState(),
	error: false
};

// Agg1 thunk
export const getMmt2Agg1DetailsData = createAsyncThunk('mmt2/getMmt2Agg1DetailsData',
	async (_, { rejectWithValue }) => {
		try {
			const query = `query { GetPairedAuthAgg1Details(collectionName: "MmtPairedAuthAgg1") { data { ExtensionStatus AuthorizationEndDate NextEligibilityStartDate AuthorizationCount } message success } }`;
			const response = await axiosInstance.post(process.env.REACT_APP_MMT_REPORTS, JSON.stringify({ query, variables: {} }));
			if (response.data.errors && response.data.errors.length > 0) {
				return rejectWithValue(response.data.errors.map(e => e.message).join(', '));
			}
			const result = response.data.data?.GetPairedAuthAgg1Details;
			if (!result?.success) {
				return rejectWithValue(result?.message || 'GetPairedAuthAgg1Details unsuccessful');
			}
			return result;
		} catch (err) {
			return rejectWithValue(err.message || 'Unexpected error');
		}
	}
);

// Agg2 thunk
export const getMmt2Agg2DetailsData = createAsyncThunk('mmt2/getMmt2Agg2DetailsData',
	async (_, { rejectWithValue }) => {
		try {
			const query = `query { GetPairedAuthAgg2Details(collectionName: "MmtPairedAuthAgg2") { data { CarlScenario AuthorizationEndDate NextEligibilityStartDate ExtensionStatus AuthorizationCount } message success } }`;
			const response = await axiosInstance.post(process.env.REACT_APP_MMT_REPORTS, JSON.stringify({ query, variables: {} }));
			if (response.data.errors && response.data.errors.length > 0) {
				return rejectWithValue(response.data.errors.map(e => e.message).join(', '));
			}
			const result = response.data.data?.GetPairedAuthAgg2Details;
			if (!result?.success) {
				return rejectWithValue(result?.message || 'GetPairedAuthAgg2Details unsuccessful');
			}
			return result;
		} catch (err) {
			return rejectWithValue(err.message || 'Unexpected error');
		}
	}
);

const mmt2Slice = createSlice({
	name: 'mmt2',
	initialState,
	reducers: {
		clearData: (state) => {
			state.agg1Data = initialDatasetState();
			state.agg2Data = initialDatasetState();
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(getMmt2Agg1DetailsData.pending, (state) => {
				state.agg1Data.loading = true;
				state.agg1Data.error = false;
			})
			.addCase(getMmt2Agg1DetailsData.fulfilled, (state, action) => {
				state.agg1Data.loading = false;
				state.agg1Data.error = false;
				state.agg1Data.data = action.payload.data || [];
				state.agg1Data.lastRefreshedDate = new Date().toISOString();
			})
			.addCase(getMmt2Agg1DetailsData.rejected, (state) => {
				state.agg1Data.loading = false;
				state.agg1Data.error = true;
			})
			.addCase(getMmt2Agg2DetailsData.pending, (state) => {
				state.agg2Data.loading = true;
				state.agg2Data.error = false;
			})
			.addCase(getMmt2Agg2DetailsData.fulfilled, (state, action) => {
				state.agg2Data.loading = false;
				state.agg2Data.error = false;
				state.agg2Data.data = action.payload.data || [];
				state.agg2Data.lastRefreshedDate = new Date().toISOString();
			})
			.addCase(getMmt2Agg2DetailsData.rejected, (state) => {
				state.agg2Data.loading = false;
				state.agg2Data.error = true;
			});
	}
});

export const { clearData } = mmt2Slice.actions;
export default mmt2Slice.reducer;